/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconFileUploaded = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--fileuploaded',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57"{...rest}><g fill="none" fillRule="evenodd"><path className="path1" fill="#86BD24" d="M28.5 57C44.24 57 57 44.24 57 28.5S44.24 0 28.5 0 0 12.76 0 28.5 12.76 57 28.5 57z"/><path className="path2" fill="#FFF" d="M43.299 16.816c-.275.04-.528.168-.72.365L22.264 37.227l-7.849-7.745a1.258 1.258 0 0 0-1.215-.331 1.238 1.238 0 0 0-.887.884 1.22 1.22 0 0 0 .35 1.196l8.724 8.61a1.258 1.258 0 0 0 1.753 0l21.19-20.91c.397-.368.506-.948.27-1.431a1.25 1.25 0 0 0-1.302-.684z"/></g></IconBase>
  )
}

IconFileUploaded.propTypes = {
  className: PropTypes.string,
}

export default IconFileUploaded
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconFileUploaded.js